import React, { FC } from 'react';
import ProductDetailCover from '../../shared/product/detail/ProductDetailCover';
import ProductDetailShortInfo from '../../shared/product/detail/ProductDetailShortInfo';
import ProductDetailExtendedInfo from '../../shared/product/detail/ProductDetailExtendedInfo';
import ProductDetailStatistics from '../../shared/product/detail/ProductDetailStatistics';
import ProductDetailLayout from '../../shared/product/detail/ProductDetailLayout';
import CampaignProductDetailSidebar from './CampaignProductDetailSidebar';
import { Article } from '../../../models/Article';
import { ProductMetaData } from '../../../models/Product';
import { ProductDetailProductGroups } from '../../shared/product/detail/ProductDetailProductGroups';
import { SingleAddOptions } from '../../../models/ListContentCheckOptions';

type Props = {
    readonly product: ProductMetaData & Article;
    readonly onAddPrice: (options: SingleAddOptions) => Promise<void>;
};

const CampaignProductDetailView: FC<Props> = ({ product, onAddPrice }) => {
    const productDetailCover = <ProductDetailCover product={product} />;
    const productDetailShortInfo = <ProductDetailShortInfo product={product} />;
    const productDetailExtendedInfo = <ProductDetailExtendedInfo product={product} />;
    const productDetailStatistics = <ProductDetailStatistics product={product} />;
    const productDetailSidebar = <CampaignProductDetailSidebar product={product} onAddPrice={onAddPrice} />;
    const embeddedEntryPageBottom = <ProductDetailProductGroups product={product} />;

    return (
        <ProductDetailLayout
            pageTitle={product.title!}
            cover={productDetailCover}
            shortInfo={productDetailShortInfo}
            statistics={productDetailStatistics}
            extendedInfo={productDetailExtendedInfo}
            sidebar={productDetailSidebar}
            bottom={embeddedEntryPageBottom}
        />
    );
};

export default CampaignProductDetailView;
